import gql from 'graphql-tag';

const PENDING_OFFER_FRAGMENT = gql`
  fragment PendingOfferFragment on PendingOffer {
    amount
    creator_dealer_id
    creator_user_id
    offer_state
    rejection_reason
    seller_dealer_id
    vehicle_id
  }
`;

export default PENDING_OFFER_FRAGMENT;
